<template>
  <power-bi code="eyJrIjoiNzZjZWQ0ODQtNmVlZS00ZTgwLWEwNWMtM2Q3ZTk5YTg0NmY0IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
